import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div ref={ref} className={className} initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
}

export function CountUp({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1400);
      setV(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);
  return <span ref={ref}>{v.toLocaleString()}{suffix}</span>;
}

export function Skeleton({ rows = 3, card = false, className = "", testId }) {
  const lines = Array.from({ length: rows }, (_, i) => i);
  return (
    <div className={`animate-fade-up ${card ? "grid gap-4 sm:grid-cols-2 lg:grid-cols-3" : "space-y-3"} ${className}`} aria-busy="true" aria-live="polite" data-testid={testId || "skeleton"}>
      {lines.map((i) => card
        ? <div key={i} className="skel h-40 rounded-card" />
        : <div key={i} className="skel h-4" style={{ width: `${[72, 92, 58, 84, 66][i % 5]}%` }} />)}
    </div>
  );
}
